<div class="d-flex justify-content-between align-items-center mb-3 sticky-header">
  <h4 class="mb-0">
    {{ 'Settings::WorkEnvironment:StatusManagement:ListTitle' | abpLocalization }}
  </h4>
  <button type="button" class="btn btn-primary btn-sm" (click)="addNew.emit()">
    <i class="pi pi-plus me-2"></i>
    {{ 'Settings::WorkEnvironment:StatusManagement:AddStatus' | abpLocalization }}
  </button>
</div>
